import { render, staticRenderFns } from "./content_with_images.vue?vue&type=template&id=764b325e&scoped=true&"
import script from "./content_with_images.vue?vue&type=script&lang=js&"
export * from "./content_with_images.vue?vue&type=script&lang=js&"
import style0 from "./content_with_images.vue?vue&type=style&index=0&id=764b325e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b325e",
  null
  
)

export default component.exports